import { render, staticRenderFns } from "./pricePublic.vue?vue&type=template&id=2985fe86&scoped=true"
import script from "./pricePublic.vue?vue&type=script&lang=js"
export * from "./pricePublic.vue?vue&type=script&lang=js"
import style0 from "./pricePublic.vue?vue&type=style&index=0&id=2985fe86&prod&scoped=true&lang=scss"
import style1 from "./pricePublic.vue?vue&type=style&index=1&id=2985fe86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985fe86",
  null
  
)

export default component.exports